/***
 * @file:å½éåæå¡é¨å
 * @author linkun.he
 * @Date: 2019-06-03 10:11:13
 */
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

import { CookieService, StoreService } from '@ithinkdt/shared/browser';
import { deepMerge } from '@ithinkdt/shared/utils';
import { TranslateService } from '@ngx-translate/core';
import * as df_en from 'date-fns/locale/en';
import * as df_zh_cn from 'date-fns/locale/zh_cn';

import { includes } from 'lodash';
import { en_US, NzI18nService, zh_CN } from 'ng-zorro-antd/i18n';

import { libEnTranslations } from './assets/en';
import { libZhTranslations } from './assets/zh-CN';
import { I18nModels } from './i18n.interface';

// å½éåå­å¨çKEY
export const I18N_LANGUAGE = 'language';

export function isEnglish(lang): boolean {
  return /^en$/.test(lang);
}

@Injectable({
  providedIn: 'root',
})
export class I18NService implements I18nModels {
  private _default = 'zh-CN';
  public change$ = new BehaviorSubject<string>(null);

  public _langs = [{ code: 'zh-CN', text: 'ä¸­æ' }, { code: 'en', text: 'English' }];
  private fileNames = [{ code: 'zh-CN', name: 'zh_CN' }, { code: 'en', name: 'en_US' }];

  constructor(
    private nzI18nService: NzI18nService,
    private cookieSrv: CookieService,
    private translate: TranslateService,
    private storeSrv: StoreService
  ) {
    const defaultLan = this.storedLang() || translate.getBrowserLang();
    const lans = this._langs.map((item) => item.code);
    this._default = includes(lans, defaultLan) ? defaultLan : lans[0];
    translate.addLangs(lans);
    this.setZorro(this._default).setDateFns(this._default);
    this.storeLang(this._default);
  }

  setZorro(lang: string): this {
    this.nzI18nService.setLocale(lang === 'en' ? en_US : zh_CN);
    return this;
  }

  setDateFns(lang: string): this {
    (window as any).__locale__ = lang === 'en' ? df_en : df_zh_cn;
    return this;
  }

  get change(): Observable<string> {
    return this.change$.asObservable().pipe(filter((w) => w != null));
  }

  use(lang: string): void {
    lang = lang || this.translate.getDefaultLang();
    if (this.currentLang === lang) {
      return;
    }
    this.setZorro(lang).setDateFns(lang);
    this.storeLang(lang);
    this.translate.use(lang).subscribe(() => this.change$.next(lang));
  }

  /** è·åè¯­è¨åè¡¨ */
  getLangs() {
    return this._langs;
  }

  /**
   *  ç¿»è¯
   * @param key éè¦ç¿»è¯çé®
   * @param value éè¦æå¥çå¼
   * exp:
   * key: demokey, value: 'èè';
   *   zh-CN.json
   *     `demokey: 'ä»åæä¸åª{value},å®å¾å¯ç±'`
   *   ç¼è¯å:
   *      `'ä»åæä¸åªèè,å®å¾å¯ç±'`
   */
  interpret(key?: string, value?: string): string {
    if (!key) {
      return;
    }
    const insetValue = { value: '' };
    insetValue.value = value || '';
    return this.translate.instant(key, insetValue);
  }

  /** é»è®¤è¯­è¨ */
  get defaultLang() {
    return this._default;
  }

  /** å½åè¯­è¨ */
  get currentLang() {
    return this.translate.currentLang || this.translate.getDefaultLang() || this._default;
  }

  // document.cookie = 'locale=en_US';

  // å­éä¸­çè¯­è¨
  storeLang(lang: string) {
    const transLang = this.fileNames.filter((f) => f.code === lang)[0].name;
    this.cookieSrv.set('locale', transLang, null, '/');
  }

  // åå­å¨çè¯­è¨
  storedLang() {
    const transLang = this.cookieSrv.get('locale');
    if (!transLang) {
      return '';
    }
    const unTransLang = this.fileNames.filter((f) => f.name === transLang);
    return unTransLang[0].code;
  }

  // åæ¢è¯­è¨æ¶è·åi18næ°æ®
  setTranslations(lang: string) {
    const hasTranslations = this.translate.translations.hasOwnProperty(lang);
    // å·²å­å¨è¯­è¨æ°æ®åç´æ¥ä½¿ç¨
    if (hasTranslations) {
      this.use(lang);
    } else {
      // æ²¡æåå»åå¹¶é¡¹ç®ålibåä¸­çï¼ä»¥é¡¹ç®ä¸­ä¸ºä¸»ã
      this.mergeTransitions(lang);
    }
  }

  // åå¹¶é¡¹ç®ålibåéçi18néç½®
  mergeTransitions(lang: string) {
    const libTranslations = isEnglish(lang) ? libEnTranslations : libZhTranslations;
    this.getProjectTranslations(lang, (projectTranslations) => {
      const translations = deepMerge(libTranslations, projectTranslations);
      this.translate.setTranslation(lang, translations, true);
      this.use(lang);
    });
  }

  getProjectTranslations(lang: string, cb: (p) => void) {
    this.translate.getTranslation(lang).subscribe((projectTranslations) => {
      cb(projectTranslations);
    });
  }

  // åå§åæ¶é¡¹ç®æ¶ï¼è·ålibååi18næ°æ®
  get defaultLibLangData(): object {
    return isEnglish(this.defaultLang) ? libEnTranslations : libZhTranslations;
  }

  /**
   * è®¾ç½®i18nå½éå
   * PSï¼å½éåå·æ°æºå¶ä¸çè¡¥åæ¹æ³
   */
  setLanguage() {
    const lang = this.storeSrv.get(I18N_LANGUAGE, true) || this._default;
    this.setTranslations(lang);
  }
}
